import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Constants } from './app.constants';

@Injectable({
    providedIn: 'root'
})

export class AppService {
    loaded: any;

    constructor(private http: HttpClient) { }
    
    auth(): Observable<any> {
        var payload = new HttpParams({ fromObject: environment.apis.auth.body });
        return <any>this.http.post(environment.apis.auth.url, payload,
            { headers: environment.apis.auth.headers }
        );
    }
    
    redeem(token:string, body:any): Observable<any> {
        let headers = environment.apis.redeem.headers;
        Object.assign(headers,{Authorization:`Bearer `+token});
        return <any>this.http.post(environment.apis.redeem.url, body,
            { headers: environment.apis.redeem.headers }
        );
    }

    getItem(url: string): Observable<any> {
        return this.http.get<any>(url)
          .pipe(
            catchError(this.handleError('getItems', []))
        );
    }
    
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(`${operation} failed: ${error.message}`);

            return of(result as T);
        };
    }
}